import { memo } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import { useRouter } from 'next/router';
import { ISEOLayoutProps } from './SEOLayout.types';

// This component is used to set the SEO properties of the page.
const SEOLayout = memo<ISEOLayoutProps>(
  ({
    children,
    title = '',
    description = '',
    image = 'https://cdn.perksbar.com/perksbar-web/meta.jpeg',
    author,
    keywords = [],
  }) => {
    const router = useRouter();

    const renderAnalyticsScripts = () => {
      if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod') {
        return (
          <>
            <Script src="https://www.googletagmanager.com/gtag/js?id=G-EJMW82HL3X" />
            <Script id="google-analytics">
              {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());

              gtag('config', 'G-EJMW82HL3X', {
                page_path: window.location.pathname,
              });
            `}
            </Script>
            <Script id="ms-clarity">
              {`
              (function(c,l,a,r,i,t,y){
                  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
              })(window, document, "clarity", "script", "l9qm0xbnsi");
              `}
            </Script>
          </>
        );
      }
      return null;
    };

    return (
      <>
        <Head>
          <title>{title}</title>
          <link rel="canonical" href={`https://www.perksbar.com${router.asPath}`} />
          <meta name="description" content={description} />
          <meta httpEquiv="content-language" content="en" />
          <meta name="robots" content="index,follow" />
          <meta name="referrer" content="no-referrer" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://www.perksbar.com${router.asPath}`} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image} key="image" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          {author && <meta name="author" content={author} />}
          <meta
            name="keywords"
            content={`PerksBar, Gamification, HR, Corporate, Digital Transformation, Employee Experience${
              keywords.length > 0 ? `, ${keywords.join(', ')}` : ''
            }`}
          />
        </Head>
        {children}
        {renderAnalyticsScripts()}
      </>
    );
  },
);

SEOLayout.displayName = 'SEOLayout';

export default SEOLayout;
